import {getAnalytics, Analytics, logEvent} from "firebase/analytics";
import {initializeApp} from "firebase/app";
import {firebaseConfig} from "./config";

const app = initializeApp(firebaseConfig, "DS_APP");

declare global {
  interface Window {
    AnalyticsWebInterface: any;
  }
}

export enum FIREBASE_EVENT {
  APPLIED_FOR_LOAN = "APPLIED_FOR_LOAN",
  NEW_UI_UX_ROLLOUT_25 = "NEW_UI_UX_ROLLOUT_25",
  NEW_UI_UX_ROLLOUT_25_ERROR = "NEW_UI_UX_ROLLOUT_25_ERROR",
  digilocker_initiated = "digilocker_initiated",
  digilocker_success = "digilocker_success",
  digilocker_denied = "digilocker_denied",
  digilocker_failed = "digilocker_failed",
}

let firebaseAnalytics: Analytics;

export const initFirebaseAnalytics = () => {
  if (!firebaseAnalytics) {
    firebaseAnalytics = getAnalytics(app);
  }
  return firebaseAnalytics;
};

export const logFirebaseEvent = (
  eventName: FIREBASE_EVENT,
  eventParams?: {[key: string]: any},
) => {
  if (!eventName) {
    return;
  }
  if (window.AnalyticsWebInterface) {
    window.AnalyticsWebInterface.logEvent(
      eventName,
      JSON.stringify(eventParams),
    );
  } else {
    const analytics = initFirebaseAnalytics();
    logEvent(analytics, eventName, eventParams);
  }
};

export const logFirebaseEventAsync = (
  eventName: FIREBASE_EVENT,
  eventParams?: {[key: string]: any},
) => {
  return new Promise((resolve) => {
    logFirebaseEvent(eventName, eventParams);
    setTimeout(() => {
      resolve("done");
    }, 2000);
  });
};
